import React from "react";

import { css } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Page } from "@/uiKit/atoms/page/Page.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";
import { PageHeader } from "@/uiKit/atoms/page/PageHeader.tsx";
import { OngoingGroupInclusions } from "@/uiKit/organisms/PatientSync/OngoingInclusion/OngoingGroupInclusions.tsx";

export const PatientSyncOngoingImportsPage: React.FC = () => {
  const styles = useStyles(makeStyles);

  return (
    <Page id="PatientSyncOngoingImportsPage" className={styles.container}>
      <PageHeader />
      <PageContent className={styles.content}>
        <OngoingGroupInclusions />
      </PageContent>
    </Page>
  );
};

const makeStyles = () => ({
  container: css({}),
  content: css({}),
});
